<template>
  <v-container class="py-12">
    <div class="text-center mb-12">
      <h1 class="text-h4 text-sm-h3">{{ headers.title }}</h1>

      <div class="subtitle-1 text--secondary mt-2">
        {{ headers.sub }}
      </div>

      <v-progress-circular
        class="mt-6"
        indeterminate
        v-if="step === 'validation'"
      ></v-progress-circular>
    </div>

    <v-card
      max-width="400"
      class="mx-auto rounded-lg"
      v-if="step === 'resend'"
    >
      <v-card-title class="justify-center">
        <v-img
          :src="require('@/assets/undraw_confidential_letter_w6ux.svg')"
          height="100"
          contain
        ></v-img>
        Confirmation
      </v-card-title>

      <v-card-text>
        <v-form ref="form" @submit.prevent="send">
          <v-text-field
            label="Adresse e-mail"
            v-model="email"
            :rules="rules.email"
            validate-on-blur
            :error-messages="emailErrorText"
            @change="emailErrorText = ''"
            outlined
            :disabled="loading || waitTime !== 31"
          ></v-text-field>

          <v-btn
            color="primary"
            block
            :loading="loading"
            :disabled="waitTime !== 31"
            x-large
            type="submit"
          >
            Renvoyer {{ waitTime !== 31 ? `(${waitTime})` : '' }}
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import rulesMixin from '@/mixins/rulesMixin';

const axios = require('axios').default;

export default {
  name: 'VerifyEmail',

  mixins: [rulesMixin],

  data: () => ({
    step: null,
    email: '',
    emailErrorText: '',
    loading: false,
    waitTime: 31,
  }),

  created() {
    if (this.$route.query.jeton) {
      this.step = 'validation';
      this.validateEmail();
    } else {
      this.step = 'resend';
    }
  },

  computed: {
    headers() {
      if (this.step === 'validation') {
        return {
          title: 'Validation',
          sub: 'La validation de votre adresse e-mail est en cours...',
        };
      }
      return {
        title: 'Renvoi d\'email',
        sub: 'Introduisez votre adresse e-mail pour renvoyer l\'email de confirmation',
      };
    },
  },

  methods: {
    async send() {
      if (!this.$refs.form.validate()) return;
      try {
        this.loading = true;
        const response = await axios.post('renvoi_email', { email: this.email });
        if (response.data === 'Email candidat non trouvé') {
          this.emailErrorText = 'L\'adresse n\'a pas été trouvée ou est déjà validée';
        } else {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Un e-mail vous a été envoyé, consultez-le pour activer votre compte',
          });
          const timer = setInterval(() => {
            this.waitTime -= 1;
            if (this.waitTime === 0) {
              clearInterval(timer);
              this.waitTime = 31;
            }
          }, 1000);
        }
      } catch {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Un problème est survenu, actualisez la page',
        });
      } finally {
        this.loading = false;
      }
    },

    async validateEmail() {
      try {
        const response = await axios.get(`valid_email?jeton=${this.$route.query.jeton}`);
        if (response.data === 'Ok validé') {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Votre adresse email a bien été validée',
          });
          if (this.$store.getters.isAuth) {
            this.$store.dispatch('getUserData')
              .then(() => {
                this.$router.push('/profile');
              })
              .catch(() => {
                this.$store.commit('SET_SNACKBAR', {
                  isActive: true,
                  text: 'Impossible de récupérer les infos de votre profil, reconnectez-vous',
                });
                this.$router.push('/login');
              });
          } else {
            this.$router.push('/login');
          }
        } else if (response.data === 'Jeton expiré') {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Le lien de confirmation a expiré, renvoyez-en un',
          });
          this.step = 'resend';
        } else {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Impossible de vérifier votre adresse e-mail',
          });
          this.step = 'resend';
        }
      } catch (error) {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Une erreur est survenue, actualisez la page',
        });
      }
    },
  },
};
</script>
